// extracted by mini-css-extract-plugin
module.exports = {"container":"StoreCostModificators_container__2KAAn","leftSided":"StoreCostModificators_leftSided__2n74Y"};